"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var reconnect_js_1 = require("reconnect.js");
function cls(arr) {
  return arr.filter(function (item) {
    return typeof item === 'string';
  }).join(' ');
}
function FilterMenuTop(props) {
  var cat = props.cat,
    updateCat = props.updateCat,
    _a = props.mobile,
    mobile = _a === void 0 ? false : _a;
  var categories = reconnect_js_1.useOutlet(props.categories)[0];
  return react_1.default.createElement(Wrapper, {
    className: cls(['rev-FilterMenuTop', mobile && 'mobile'])
  }, react_1.default.createElement("div", {
    className: "header"
  }, react_1.default.createElement("div", {
    className: "label",
    onClick: function onClick() {
      return updateCat('');
    }
  }, "\u7522\u54C1\u5206\u985E")), react_1.default.createElement("div", {
    className: "items"
  }, categories.map(function (catL1) {
    return react_1.default.createElement(TopLevelCategory, {
      key: catL1.name,
      catL1: catL1,
      cat: cat,
      updateCat: updateCat
    });
  })));
}
exports.default = FilterMenuTop;
function TopLevelCategory(props) {
  var catL1 = props.catL1,
    cat = props.cat,
    updateCat = props.updateCat;
  var currL1 = (cat || '').split('-')[0];
  var selected = currL1 === catL1.name;
  return react_1.default.createElement(CatL1Wrapper, {
    className: cls(['L1', selected && 'selected'])
  }, react_1.default.createElement("div", {
    className: "header"
  }, react_1.default.createElement("div", {
    className: "label",
    onClick: function onClick() {
      return updateCat(catL1.name);
    }
  }, catL1.display || catL1.name)));
}
var CatL1Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: white;\n  border-radius: 12px;\n  padding: 10px 15px;\n  margin: 0px 10px 10px 10px;\n  border: 1px solid #e8e8e8;\n\n  &:hover,\n  &:active {\n    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.08);\n  }\n\n  &.selected {\n    background-color: var(--primaryColor);\n    border: 1px solid var(--primaryColor);\n\n    & > .header {\n      color: white;\n    }\n  }\n\n  & > .header {\n    display: flex;\n    align-items: center;\n    font-size: 1rem;\n    color: #727272;\n\n    & > .label {\n      flex: 1;\n      cursor: pointer;\n      line-height: 22px;\n      text-align: center;\n    }\n  }\n"], ["\n  background-color: white;\n  border-radius: 12px;\n  padding: 10px 15px;\n  margin: 0px 10px 10px 10px;\n  border: 1px solid #e8e8e8;\n\n  &:hover,\n  &:active {\n    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.08);\n  }\n\n  &.selected {\n    background-color: var(--primaryColor);\n    border: 1px solid var(--primaryColor);\n\n    & > .header {\n      color: white;\n    }\n  }\n\n  & > .header {\n    display: flex;\n    align-items: center;\n    font-size: 1rem;\n    color: #727272;\n\n    & > .label {\n      flex: 1;\n      cursor: pointer;\n      line-height: 22px;\n      text-align: center;\n    }\n  }\n"])));
var Wrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: sticky;\n  top: var(--topNavBarHeight);\n\n  & > .header {\n    padding: 15px 10px;\n    display: flex;\n    align-items: center;\n\n    & > .label {\n      flex: 1;\n      font-size: 1.3rem;\n      cursor: pointer;\n      text-align: center;\n    }\n  }\n\n  & > .items {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-wrap: wrap;\n    max-width: 800px;\n    margin: 0 auto;\n  }\n\n  &.mobile {\n    padding: 0 8px;\n  }\n"], ["\n  position: sticky;\n  top: var(--topNavBarHeight);\n\n  & > .header {\n    padding: 15px 10px;\n    display: flex;\n    align-items: center;\n\n    & > .label {\n      flex: 1;\n      font-size: 1.3rem;\n      cursor: pointer;\n      text-align: center;\n    }\n  }\n\n  & > .items {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-wrap: wrap;\n    max-width: 800px;\n    margin: 0 auto;\n  }\n\n  &.mobile {\n    padding: 0 8px;\n  }\n"])));
var templateObject_1, templateObject_2;